module.exports = __webpack_public_path__ + "static/media/nl-NL.23d06909.md";